<template>
  <section id="zscxinfo" class="course-page-section">
    <div class="container">
      <div class="row">
        <div class="col-md-9">
          <el-form :model="data" ref="ruleForm" label-width="150px">
            <div class="box">
              <div class="title" style="display: flex; align-items: center;">证书信息</div>
              <el-form-item label-width="0">
                <el-col :span="16">
                  <!-- <el-form-item v-if="data.CertStateId == 2" class="yc-item" label="证书状态：">
                    {{data.CertStateName}}
                  </el-form-item> -->
                  <el-form-item label="证书编号：">
                    {{data.Code}}
                  </el-form-item>
                  <el-form-item label="姓名：">
                    {{data.Name}}
                  </el-form-item>
                  <el-form-item label="性别：">
                    {{data.SexDescription}}
                  </el-form-item>
                  <el-form-item label="身份证号：">
                    {{data.IdNumber}}
                  </el-form-item>
                  <el-form-item label="岗位：">
                    {{data.CourseName}}
                  </el-form-item>
                  <el-form-item label="专业：">
                    {{data.JobName}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <div style="width: 160px; margin-top: -64px;">
                      <k-btn-img :slides="[data.Pic]" class="avatar-uploader">
                        <template slot="img" slot-scope="scope1">
                          <img :id="'img_avatar_1'" :data-original="scope1.item" :src="scope1.item" style="width: 160px; height: 100%;object-fit: cover;">
                        </template>
                        <template slot="btn" slot-scope="scope2">
                          <div @click="onClickImg('img_avatar_1')">查看大图</div>
                        </template>
                      </k-btn-img>
                      <div style="text-align: center; line-height: 16px; color: #777;">电子证件照</div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-form-item>
              <el-form-item label="有效期至：">
                {{data.BeginDate | dateformat('YYYY年MM月DD日')}} 至 {{data.ExpirDate | dateformat('YYYY年MM月DD日')}}
              </el-form-item>
              <el-form-item label="培训单位：">
                {{data.Authority}}
              </el-form-item>
              <el-form-item label="发证日期：">
                {{data.CreateTime | dateformat('YYYY年MM月DD日')}}
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="col-md-3">
          <component :is="newsView" ref="newsView"></component>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { Vue } from '../base/base.js';

import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';

let viewer = null;
export default {
  created: function () {
    this.newsView = Vue.component('newsView', function (resolve) {
      require(['./new/list'], resolve)
    });
  },
  data() {
    return {
      data: {
        Code: null,
        CourseName: null,
        JobName: null,
        Name: null,
        IdNumber: null,
        Pic: null,
        SexDescription: null,
        Authority: null,
        FirstDate: null,
        ExpirDate: null,
        Url: null,
        CreateTime: null
      }
    }
  },
  filters: {
    dateformat(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr === null) {
        return '';
      }
      return moment(dataStr).format(pattern)
    }
  },
  mounted() {
    viewer = null;
    this.data = _.assignIn(this.data, this.$route.query);
  },
  methods: {
    onClickImg(id) {
      if (viewer == null) {
        // 初始化 viewer.js
        viewer = new Viewer(document.getElementById('zscxinfo'), {
          url: 'data-original',
          filter: function (image) {
            if ($(image).prop('src') !== '') {
              return true;
            }
          }
        });
      }
      $('#' + id).click();
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  margin-bottom: 64px;
  font-size: 16px;
  .title {
    margin-bottom: 32px;
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }

  .avatar-uploader {
    width: 160px;
    height: 200px;
    margin-bottom: 8px;
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100%;
      height: 100%;
      line-height: 200px;
      text-align: center;
    }
    .avatar {
      width: 160px;
      height: 200px;
      display: block;
      position: relative;
      z-index: 2;
    }
    // .avatar-title {
    //   margin-top: -80px;
    //   display: flex;
    //   justify-content: center;
    //   font-size: 14px;
    //   color: #a8a8a8;
    // }
    img {
      border: 1px solid #dedede;
      border-radius: 6px;
      cursor: pointer;
    }
    i {
      border: 1px solid #dedede;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      &:hover {
        border-color: #409eff;
      }
    }
    .btn-img {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 5px;
      position: absolute;
      top: 0;
      div {
        flex: none;
        font-size: 16px;
        padding-right: 24px;
        cursor: pointer;
      }
      div:last-child {
        flex: none;
        font-size: 16px;
        padding-right: 0;
        cursor: pointer;
      }
    }
  }
}
</style>
<style scoped>
#zscxinfo >>> .el-form-item {
  margin-bottom: 0 !important;
}
#zscxinfo >>> .el-form-item__content {
  line-height: 1.5em;
  min-height: 40px;
  display: flex;
  align-items: center;
}
.el-form-item >>> .el-form-item__content {
  font-size: 16px !important;
  color: #333;
}
.yc-item >>> .el-form-item__label,
.yc-item >>> .el-form-item__content {
  color: #ff6715 !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/home/diploma_info.vue